// Deletes the object parameters which values are null or undefined, and return the edited object (not a copy).
// For example: `{ a: 'chocolate', b: null }` would become `{ a: 'chocolate' }`.
export const removeNullParametersFromObject = obj => Object.keys(obj).reduce((result, parameter) => {
	if (result[parameter] == null || (result[parameter].length != null && result[parameter].length <= 0))
		delete result[parameter];

	return result;
}, obj);
